var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"text-center text-bpb-green-03 mb-5"},[_vm._v("Empresas que son nuestros aliados")]),_vm._l((_vm.aliados),function(aliado){return _c('div',{staticClass:"image-wrapper"})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }